import React from 'react';
import { Accent, SectionHeading } from './SectionHeading';
import { TeachingFlow } from './TeachingFlow';
import { afterPurchase } from '../../data/content';
export function AfterPurchaseSection() {
  return <section aria-labelledby="after-heading" className="bg-brand-ivory px-5 py-16 lg:px-8 lg:py-24" data-id="element-32" data-mp="6s682iug4z2l">
      <div className="mx-auto max-w-6xl" data-id="element-33" data-mp="bk6b4k5tc83e">
        <SectionHeading id="after-heading" eyebrow="What Happens After Purchase?" title={<>
              From Checkout to <Accent data-id="element-35" data-mp="lg9chnsuc2pa">Your Next Class.</Accent>
            </>} data-id="element-34" data-mp="bl7oivaax6oa" />

        <ol className="relative mt-14 grid gap-8 sm:grid-cols-2 lg:grid-cols-6 lg:gap-5" data-id="element-36" data-mp="pie5ckbgsvav">
          <span aria-hidden="true" className="absolute left-[8%] right-[8%] top-5 hidden h-px bg-brand-charcoal/15 lg:block" data-id="element-37" data-mp="uhqoov34nk8p" />
          {afterPurchase.map(step => <li key={step.number} className="relative flex flex-col items-start lg:items-center lg:text-center" data-id="element-38" data-mp="2w8u0voso16vd">
              <span className="relative flex h-10 w-10 items-center justify-center rounded-full border border-brand-gold/60 bg-brand-ivory font-display text-[1.2rem] font-bold text-brand-gold" data-id="element-39" data-mp="1kv6gb1emw7m1">
                {step.number}
              </span>
              <p className="mt-4 font-body text-[13px] font-semibold uppercase tracking-[0.1em] text-brand-charcoal" data-id="element-40" data-mp="1c0iclfopixzc">
                {step.title}
              </p>
              <p className="mt-1.5 text-[14px] leading-relaxed text-brand-charcoal/65" data-id="element-41" data-mp="23sr7wg8s9kac">{step.description}</p>
            </li>)}
        </ol>

        <TeachingFlow steps={['Open', 'Prepare', 'Teach']} className="mt-14" data-id="element-42" data-mp="1zqcljm5wo2eb" />
      </div>
    </section>;
}